import tr from './translation'

//Write here all the changes to translations that are not correct
tr.messages.team.management.members = '{location} dan ekip üyeleri'
tr.messages.cart.amountItems = "{amount} tek kalem"
tr.messages.cart.amount = "{amount} öğe konumları"
export default tr
